import React from 'react';
import { X } from 'lucide-react';
import {
  PROFILE_CROP_ZOOM_MAX,
  cropFrameDimensions,
  cropFitZoom,
  cropZoomMin,
} from '../pages/admin/linksConfig.utils';

export default function LinksConfigCropModal({
  profileCrop,
  croppingProfile,
  cropError,
  profileCropImageStyle,
  cropImageRef,
  onClose,
  onApply,
  onImageLoad,
  onImageError,
  onPointerDown,
  onPointerMove,
  onPointerUp,
  onZoomChange,
}) {
  if (!profileCrop?.previewUrl) return null;

  const cropTarget = profileCrop.target || 'profile';
  const isCoverCrop = cropTarget === 'cover';
  const isPromotionCrop = cropTarget === 'promotion';
  const isExternalCrop = cropTarget.startsWith('external:');
  const frame = cropFrameDimensions(cropTarget, profileCrop);
  const cropTitle = isPromotionCrop
    ? 'Ajustar banner promocional'
    : isCoverCrop
    ? 'Ajustar foto de capa'
    : isExternalCrop
      ? 'Ajustar imagem do link'
      : 'Ajustar foto principal';
  const cropFrameModifier = isPromotionCrop
    ? 'is-promotion'
    : isCoverCrop
    ? 'is-cover'
    : isExternalCrop
      ? 'is-square'
      : '';

  return (
    <div className="fsl-crop-modal" role="dialog" aria-modal="true" aria-labelledby="fsl-crop-title">
      <div className="fsl-crop-panel">
        <div className="fsl-crop-head">
          <h2 id="fsl-crop-title">{cropTitle}</h2>
          <button
            type="button"
            className="fsl-crop-close"
            onClick={onClose}
            disabled={croppingProfile}
            title="Fechar"
            aria-label="Fechar"
          >
            <X size={18} strokeWidth={2.5} />
          </button>
        </div>

        <div
          className={`fsl-crop-frame ${cropFrameModifier}`}
          style={{ width: frame.width, height: frame.height }}
          onPointerDown={onPointerDown}
          onPointerMove={onPointerMove}
          onPointerUp={onPointerUp}
          onPointerCancel={onPointerUp}
          title="Arraste para posicionar"
        >
          <img
            ref={cropImageRef}
            src={profileCrop.previewUrl}
            alt=""
            draggable={false}
            style={profileCropImageStyle}
            onLoad={onImageLoad}
            onError={onImageError}
          />
        </div>

        {cropError && (
          <p className="fsl-crop-error">{cropError}</p>
        )}

        <label className="fsl-crop-control">
          <span>Zoom · {Math.round(profileCrop.zoom * 100)}%</span>
          <input
            type="range"
            min={cropZoomMin(profileCrop)}
            max={PROFILE_CROP_ZOOM_MAX}
            step="0.01"
            value={profileCrop.zoom}
            onChange={onZoomChange}
            disabled={croppingProfile || !profileCrop.naturalWidth}
          />
        </label>

        <button
          type="button"
          className="fsl-crop-secondary"
          disabled={croppingProfile || !profileCrop.naturalWidth}
          onClick={() => onZoomChange({ target: { value: cropFitZoom(profileCrop) } })}
        >
          Caber imagem inteira
        </button>
        <p className="fsl-crop-help">
          Arraste para posicionar. Reduza ou amplie o zoom; ao reduzir, podem aparecer margens transparentes.
        </p>

        <div className="fsl-crop-actions">
          <button
            type="button"
            className="fsl-crop-secondary"
            onClick={onClose}
            disabled={croppingProfile}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="fsl-crop-primary"
            onClick={onApply}
            disabled={croppingProfile || !profileCrop.naturalWidth}
          >
            {croppingProfile ? 'Preparando...' : 'Usar imagem'}
          </button>
        </div>
      </div>
    </div>
  );
}
